import { Suspense } from 'react';
import Loader from '@/components/common/loader/Loader';
import PrivateRoute from '@/routing/PrivateRoute';

const RouteWrapper = ({ element, isPrivate = true }) => {
  const content = <Suspense fallback={<Loader />}>{element}</Suspense>;
  return isPrivate ? <PrivateRoute>{content}</PrivateRoute> : content;
};

export default RouteWrapper;
